import React from "react";
import { useCart } from "../../contexts/CartContext";
import { Outlet, useLocation } from "react-router-dom";
import UserNavbar from "../navbar/UserNavbar";
import './UserLayout.css';


interface UserLayoutProps {
  isAuthenticated: boolean;
  handleLogout: () => void;
  userName?: string;
}

const UserLayout: React.FC<UserLayoutProps> = ({
  isAuthenticated,
  handleLogout,
  userName,
}) => {
  const { cartItems } = useCart(); // Aquí asumimos que `cartItems` es un array
  const location = useLocation();

  
  return (
    <div className="user-layout">
      

      <UserNavbar
        isAuthenticated={isAuthenticated}
        cartItems={cartItems.length} // Pasamos la cantidad de productos como un número
        handleLogout={handleLogout}
        showSearch={location.pathname === "/products"}
      />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default UserLayout;
